import { CSSProperties } from 'react';
import { defaultTheme } from 'da-frontend-shared-ui-components';

export const questionStyle: CSSProperties = {
  marginBottom: defaultTheme.spacing.unit,
};
